/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.credentials.rpc.AchievementPublicRpc
 */

/**
 * Virtual record for map with known enum keys
 */

export const getPublicAchievementRpc = {
  serviceName: 'com.hubspot.credentials.rpc.AchievementPublicRpc',
  rpcName: 'getPublicAchievement',
  auth: 'external',
  fingerprint: 'IlAHR304DaWXUBBBFH9CUJEAXm2HbnMQ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPublicAchievementV2Rpc = {
  serviceName: 'com.hubspot.credentials.rpc.AchievementPublicRpc',
  rpcName: 'getPublicAchievementV2',
  auth: 'external',
  fingerprint: 'IlAHR304DaUG1gr2q5kqppEAXm2HbnMQ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};